import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { FeatureFlagTypes } from '@raptor-fe/core';
import { ApplicationContextStore, NamedRoutes } from '@raptor-fe/services';
import { filter, map, take } from 'rxjs';

/** Sends the default landing to the DVI dashboard when the tenant has DVI, otherwise to the home page. */
export const landingGuard: CanActivateFn = () => {
    const store = inject(ApplicationContextStore);
    const router = inject(Router);

    const target = (): UrlTree =>
        router.parseUrl(
            store.features().includes(FeatureFlagTypes.DigitalVehicleInspection) ? NamedRoutes.dashboard().path : NamedRoutes.home().path,
        );

    if (store.isReady()) {
        return target();
    }

    return toObservable(store.isReady).pipe(
        filter((isReady) => isReady),
        take(1),
        map(() => target()),
    );
};
